import { useTranslation } from "react-i18next";

interface StaffLang {
  id: number;
  title: string;
  value: "ru" | "uz";
  image: string;
}

export const useStaffLangs = (): StaffLang[] => {
  const { t } = useTranslation();

  return [
    {
      id: 0,
      title: t("language-ru"),
      value: "ru",
      image: "/images/russian.svg",
    },
    {
      id: 1,
      title: t("language-uz"),
      value: "uz",
      image: "/images/uzbek.svg",
    },
  ];
};
